(() => {
	const INSTANCES = []
	class CityDomainsDropdown {
		constructor (id, base, path, citypage) {
			INSTANCES.push(this)
			this.id = id
			this.base = base
			this.path = path
			this.citypage = citypage
			this.citylist = []
			this.cookieName = 'city'
			
			document.addEventListener('DOMContentLoaded', this.init.bind(this))
		}

		static get INSTANCES () {
			return INSTANCES
		}

		init () {
			this.container = document.getElementById(this.id)
			this.popup = document.getElementById('popup_cities')
			this.bindList()
			let city = this.getCity()
			if(city)
				this.setCity(city)
			this.bindMenu()
		}

		bindList(){
			let list = this.container.getElementsByClassName("cities__name");
			[...list ].forEach(element => {
				element.addEventListener('click', this.setCookie.bind(this))
				let name =  element.getAttribute('data-city')
				let label =  element.getAttribute('title')
				this.citylist[name] = label
			})

		}

		bindMenu(){
			let menu = document.getElementById('navbar-menu')
			let list = menu.getElementsByClassName("city-link");
			[...list ].forEach(element => {
				element.addEventListener('click', this.handleMenu.bind(this))
			})

		}

		handleMenu(event) {
			if (!this.getCity(this.cookieName)) {
				this.route = event.currentTarget.getAttribute('data-query')
				event.preventDefault()
				this.popup.style.display = 'block'
				return false;
			}

		}
		getCity () {
			let name = this.cookieName + '='
			let decodedCookie = decodeURIComponent(document.cookie)
			let ca = decodedCookie.split(';')
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i]
				while (c.charAt(0) === ' ') {
					c = c.substring(1)
				}
				if (c.indexOf(name) === 0) {
					return c.substring(name.length, c.length)
				}
			}
			return ''
		}

		setCookie (event) {
			let city = event.target.getAttribute('data-city')
			let d = new Date()
			d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000))
			let expires = 'expires=' + d.toUTCString()
			document.cookie = this.cookieName + '='+city+';' + expires + ';path=/'
			this.popup.style.display = 'none'
			window.location.href = this.base + (this.citypage ? city + '/' : '') + this.path;

		}
	
		setCity(city) {
			let label = this.citylist[city]
			if(document.querySelector('#city-contact-with-us'))	
				document.querySelector('#city-contact-with-us').value = label
			if(document.querySelector('#city-fast-contact'))
				document.querySelector('#city-fast-contact').value = label
			if(document.querySelector('#city-clear-view'))
				document.querySelector('#city-clear-view').value = label	
			let list = document.querySelectorAll('[data-city-name]');
			[...list ].forEach(element => {
				element.innerHTML = label
			})
		}
	}
	if (window.CityDomainsDropdown === undefined) { window.CityDomainsDropdown = CityDomainsDropdown }
})()



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_choose_city_dropdown/script.js